export const twitchData = [
    { id: 1, name: 'Twitch 100%' },
    { id: 2, name: 'Twitch 150%' },
    { id: 3, name: 'Twitch 200%' }
];